import { useId, useState } from 'react';
import { useI18n } from '../i18n';
import styles from './BookingCancellationPolicyPanel.module.css';

type BookingCancellationPolicyPanelProps = {
  onContinue: () => void;
  onCancel: () => void;
};

export function BookingCancellationPolicyPanel({
  onContinue,
  onCancel,
}: BookingCancellationPolicyPanelProps) {
  const { t } = useI18n();
  const agreeId = useId();
  const [agreed, setAgreed] = useState(false);

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby={`${agreeId}-title`}
    >
      <div className={styles.sheet}>
        <div className={styles.headerRow}>
          <h2 className={styles.title} id={`${agreeId}-title`}>
            {t('bookings.cancellationPolicy.title')}
          </h2>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onCancel}
            aria-label={t('bookings.cancellationPolicy.cancel')}
          >
            ×
          </button>
        </div>

        <ul className={styles.rules}>
          <li className={styles.rule}>{t('bookings.cancellationPolicy.ruleWeek')}</li>
          <li className={styles.rule}>{t('bookings.cancellationPolicy.ruleDay')}</li>
          <li className={styles.rule}>{t('bookings.cancellationPolicy.ruleLate')}</li>
        </ul>

        <label className={styles.agreeRow} htmlFor={agreeId}>
          <input
            id={agreeId}
            type="checkbox"
            className={styles.agreeCheckbox}
            checked={agreed}
            onChange={(event) => setAgreed(event.target.checked)}
          />
          <span className={styles.agreeLabel}>{t('bookings.cancellationPolicy.agreeLabel')}</span>
        </label>

        <button
          type="button"
          className={styles.continueButton}
          disabled={!agreed}
          onClick={onContinue}
        >
          {t('bookings.cancellationPolicy.continue')}
        </button>
        <button type="button" className={styles.cancelButton} onClick={onCancel}>
          {t('bookings.cancellationPolicy.cancel')}
        </button>
      </div>
    </div>
  );
}
